
    var riot = require('riot')
    //src: starling/src/tags/modal-share/autocomplete-contacts.html
riot.tag2('autocomplete-contacts',
  '<h4 class="contacts_title">Suggestions</h4> <ul ref="list" class="contacts_list"> <li each="{user, index in results}" class="contacts_item {selectedItem === index && \'contacts_item--selected\'}" oncontextmenu="{stopRightClick}" onmousedown="{makeSelection.bind(null, user)}"> <img class="avatar contacts_avatar" riot-src="{user.avatar_url || \'/images/avatar.png\'}" alt="{user.display_name}"> <div class="contacts_info"> <h4 class="contacts_name">{user.display_name}</h4> <span class="contacts_email">{user.email}</span> </div> </li> </ul>',
  '',
  'show="{isOpen}" class="contacts"', function(opts) {
'use strict';

var _this = this;

var _sharedUtil = require('lib/shared-util');

var _opts = opts,
    canvas = _opts.canvas;

canvas.autocompleteContactsTag = this;

this.selectedItem = -1;
this.isOpen = false;
this.contacts = [];

this.show = function () {
  if (_this.results.length === 0) {
    _this.selectedItem = -1;
  }

  _this.isOpen = true;
  _this.update();
};

this.hide = function () {
  _this.results = [];
  _this.selectedItem = -1;
  _this.isOpen = false;
  _this.update();
};

this.makeSelection = function (selection, e) {
  _this.cb(selection);
  _this.hide();
};

this.incrementSelected = function (diff) {
  if (_this.selectedItem + diff < -1) {
    _this.selectedItem = -1;
  } else if (_this.selectedItem + diff >= _this.results.length) {
    _this.selectedItem = _this.results.length - 1;
  } else {
    _this.selectedItem += diff;
  }

  _this.update();
};

this.getSelectedResult = function () {
  if (_this.selectedItem < 0) {
    return;
  }

  if (_this.results) {
    return _this.results[_this.selectedItem];
  }
};

this.setContacts = function (contacts) {
  _this.contacts = contacts;
};

this.setCallback = function (cb) {
  _this.cb = cb;
};

this.showResults = function (q) {
  if (!q.trim()) {
    _this.hide();
  }

  var results = [];

  for (var _iterator = _this.contacts, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var user = _ref;

    var rx = new RegExp((0, _sharedUtil.escapeRegExp)('' + q), 'i');
    if (user && user.email && user.email.match(rx) || user.display_name && user.display_name.match(rx)) {
      results.push(user);
    }
    if (results.length >= 5) break;
  }

  _this.results = results;

  if (results.length) {
    _this.show();
  } else {
    _this.hide();
  }
};

this.stopRightClick = function (e) {
  e.stopPropagation();
  canvas.hidePopups();
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('autocomplete-contacts')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/modal-share/autocomplete-contacts.html
// module id = 760
// module chunks = 0